"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _Overlay = _interopRequireDefault(require("../../components/Overlay"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BuilderComponent = function BuilderComponent(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    dispatch = _ref.dispatch,
    match = _ref.match,
    projectLinks = _ref.projectLinks,
    restrictionsLevel = _ref.restrictionsLevel;
  var flowId = Number(match.params.flowId);
  var projectId = Number(match.params.projectId);
  return /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
    title: "Survey Builder",
    backLink: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      onClick: function onClick() {
        return dispatch((0, _admin.loadProject)(projectId));
      },
      to: projectLinks.design
    }, "Go to Quest List"),
    breadcrumbs: breadcrumbs,
    inModal: true
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Builder, {
    flowId: flowId,
    showTitle: false,
    restrictionsLevel: restrictionsLevel
  }));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    projectLinks: (0, _admin2.getProjectLinks)(state.assignment.admin),
    breadcrumbs: (0, _admin2.getFlowBreadcrumbs)(state.assignment.admin, props),
    restrictionsLevel: (0, _admin2.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(BuilderComponent);
exports["default"] = _default;